var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_34_1",
    "data-name": "Component 34 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_104",
    "data-name": "Vrstva 104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M8.26,17.34a.9.9,0,0,0,1.22.2l2.32-2.33,2.32,2.33a.9.9,0,0,0,1.22-.2.9.9,0,0,0,.2-1.22L13.21,13.8l2.33-2.32a.9.9,0,0,0-.2-1.22.9.9,0,0,0-1.22-.2L11.8,12.39,9.48,10.06a.9.9,0,0,0-1.22.2.9.9,0,0,0-.2,1.22l2.33,2.32L8.06,16.12a.9.9,0,0,0,.2,1.22Z",
    fill: "#cb0c51",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M20.8,1H3.2A1.2,1.2,0,0,0,2,2.2V5.8A1.2,1.2,0,0,0,3.2,7H4V20a3,3,0,0,0,3,3H17a3,3,0,0,0,3-3V7h.8A1.2,1.2,0,0,0,22,5.8V2.2A1.2,1.2,0,0,0,20.8,1ZM18,20a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1V7H18ZM20,5H4V3H20Z",
    fill: "#cb0c51",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.2decc5aacbd09ef0abedc092883d95e3.svg";
export { ForwardRef as ReactComponent };